<template>
    <div>
        <el-row style="margin-top: 2vh; padding: 20px;">
            <!-- 搜索表单区域：适配设备字段 -->
            <el-col :span="24">
                <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                    <el-form-item label="设备名称">
                        <el-input v-model="searchForm.deviceName" placeholder="请输入设备名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleSearch()">查询</el-button>
                        <el-button @click="resetSearch()">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-col>

            <!-- 表格区域：替换为设备实体字段 -->
            <el-col :span="24" style="margin-top: 20px;">
                <el-table ref="tableRef" :data="displayRecordList" height="65vh" style="width: 100%;" border
                    :header-cell-class-name="'table-header'" @row-click="handleRowClick" v-loading="loading">
                    <el-table-column type="selection" width="55" align="center" />
                    <el-table-column label="序号" type="index" width="70" align="center" />
                    <el-table-column prop="deviceName" label="设备名称" align="center" />
                    <el-table-column prop="deviceSerialnumber" label="设备序列号" align="center" />
                    <el-table-column prop=" dateTime" label="维保时间" align="center" />

                    <el-table-column prop=" accessories" label="使用配件" align="center" />
                    <el-table-column prop=" content" label="维保内容" align="center" />
                    <el-table-column prop="remark" label="备注" align="center" />
                    <el-table-column prop="repairman" label="操作人" align="center" />
                    <!-- 核心修改：调用getRoomName方法显示功能间名称 -->
                    <el-table-column label="功能间" align="center">
                        <template #default="scope">
                            {{ getRoomName(scope.row.roomId) }}
                        </template>
                    </el-table-column>

                </el-table>

                <!-- 分页区域 -->
                <div style="margin-top: 20px; text-align: center;">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="totalCount" :disabled="loading">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
        <!-- 图片预览弹窗 -->
        <el-dialog :title="previewTitle" :visible.sync="previewVisible" width="80%" height="30vh" append-to-body
            class="image-preview-dialog">
            <div class="preview-content">
                <img :src="previewImageUrl" class="preview-img" style="width: 500px;height:60vh;">
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="previewVisible = false">关闭</el-button>
                <el-button type="primary" @click="downloadImage">下载图片</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getDeviceList } from "@/api/device";
import { getRoomList } from "@/api/function";
export default {
    data() {
        return {
            // 搜索表单：对齐后端实体字段
            searchForm: {
                deviceName: '',       // 设备名称
                target: '',          // 消毒目标
                status: '',          // 消毒状态
                date: ''             // 消毒日期
            },
            // 功能间列表（新增：原代码遗漏定义）
            roomList: [],
            // 原始全量数据（从接口加载）
            allRecordList: [],
            // 筛选后的全量数据
            filteredRecordList: [],
            // 当前页展示的数据
            displayRecordList: [],
            // 分页参数
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,  // 图片预览相关
            previewVisible: false,
            // 加载状态
            loading: false
        };
    },
    mounted() {
        // 初始化：先加载功能间，再加载设备（保证roomList有数据）
        this.initData();
    },
    methods: {
        // 预览图片
        previewImage(url, title) {
            if (!url) return; // 避免空链接
            this.previewImageUrl = url;
            this.previewTitle = title;
            this.previewVisible = true;
        },

        // 初始化数据：保证加载顺序
        async initData() {
            try {
                // 先加载功能间列表
                await this.loadRoomList();
                // 再加载设备数据
                await this.loadDevices();
            } catch (error) {
                this.$message.error('数据初始化失败');
                console.error('初始化失败：', error);
            }
        },

        // 加载功能间列表
        async loadRoomList() {
            try {
                const res = await getRoomList({ userId: localStorage.getItem('userId') });
                this.roomList = res.data || [];
            } catch (error) {
                this.$message.error('加载功能间列表失败');
                console.error('功能间加载失败：', error);
            }
        },

        // 根据功能间id获取名称（核心方法）
        getRoomName(roomId) {
            if (!roomId) return '未知功能间';
            // 注意：确保id类型匹配（如果后端返回的是字符串，需统一类型）
            const room = this.roomList.find(item => item.id === roomId || item.id === Number(roomId));
            return room ? room.roomName : '未知功能间';
        },

        // 获取设备（修复原代码数据赋值错误）
        async loadDevices() {
            this.loading = true; // 新增：加载时显示loading
            try {
                const res = await getDeviceList({
                    userId: localStorage.getItem('userId')
                });
                console.log('设备数据：', res.data);
                // 修复：将数据赋值给allRecordList（原代码直接赋值给displayRecordList）
                this.allRecordList = res.data || [];
                // 初始化筛选数据为全量数据
                this.filteredRecordList = [...this.allRecordList];
                // 更新总数并分页
                this.totalCount = this.filteredRecordList.length;
                this.paginateData();
            } catch (error) {
                this.$message.error('加载设备异常，请重试');
                console.error('加载设备失败：', error);
                this.allRecordList = [];
                this.filteredRecordList = [];
                this.displayRecordList = [];
                this.totalCount = 0;
            } finally {
                this.loading = false; // 新增：结束loading
            }
        },

        // 处理查询（前端筛选核心逻辑）
        handleSearch() {
            this.loading = true;
            try {
                // 重置页码到第一页
                this.currentPage = 1;

                // 前端筛选逻辑：逐条件过滤全量数据
                this.filteredRecordList = this.allRecordList.filter(item => {
                    // 1. 设备名称筛选（模糊匹配，忽略大小写）
                    if (this.searchForm.deviceName) {
                        const deviceName = (item.deviceName || '').toLowerCase();
                        const searchVal = this.searchForm.deviceName.toLowerCase();
                        if (!deviceName.includes(searchVal)) return false;
                    }

                    // 2. 消毒目标筛选（模糊匹配）
                    if (this.searchForm.target) {
                        const target = (item.target || '').toLowerCase();
                        const searchVal = this.searchForm.target.toLowerCase();
                        if (!target.includes(searchVal)) return false;
                    }

                    // 3. 消毒状态筛选（精确匹配）
                    if (this.searchForm.status !== '') {
                        if (item.status !== Number(this.searchForm.status)) return false;
                    }

                    // 4. 消毒日期筛选（精确匹配）
                    if (this.searchForm.date) {
                        if (item.date !== this.searchForm.date) return false;
                    }

                    // 所有条件都满足
                    return true;
                });

                // 更新总数并分页
                this.totalCount = this.filteredRecordList.length;
                this.paginateData();

                // 无数据提示
                if (this.totalCount === 0) {
                    this.$message.info('未查询到符合条件的设备记录');
                }
            } catch (error) {
                console.error('筛选数据失败:', error);
                this.$message.error('查询失败，请重试');
            } finally {
                this.loading = false;
            }
        },

        // 分页处理：根据当前页和页大小切割数据
        paginateData() {
            if (this.filteredRecordList.length === 0) {
                this.displayRecordList = [];
                return;
            }

            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            this.displayRecordList = this.filteredRecordList.slice(startIndex, endIndex);
        },

        // 重置搜索条件
        resetSearch() {
            // 清空搜索表单
            this.searchForm = {
                deviceName: '',
                target: '',
                status: '',
                date: ''
            };

            // 重置筛选数据为全部数据
            this.filteredRecordList = [...this.allRecordList];
            this.currentPage = 1;
            this.totalCount = this.filteredRecordList.length;
            this.paginateData();

            this.$message.info('搜索条件已重置');
        },

        // 分页大小改变
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1; // 重置到第一页
            this.paginateData();
        },

        // 当前页改变
        handleCurrentChange(val) {
            this.currentPage = val;
            this.paginateData();
        },
        // 下载图片
        downloadImage() {
            if (!this.previewImageUrl) {
                this.$message.warning('暂无图片可下载');
                return;
            }

            try {
                const link = document.createElement('a');
                link.href = this.previewImageUrl;
                link.download = `${this.previewTitle}_${new Date().getTime()}.png`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.$message.success('图片下载成功');
            } catch (error) {
                console.error('下载图片失败:', error);
                this.$message.error('图片下载失败，请重试');
            }
        },
        // 表格行点击事件（选中/取消选中行）
        handleRowClick(row) {
            this.$refs.tableRef?.toggleRowSelection(row);
        }
    }
};
</script>

<style lang="scss">
// 图片预览弹窗样式
::v-deep .image-preview-dialog {
    .preview-content {
        width: 500px;
        height: 500px;

        .preview-img {
            width: 500px;
            height: 500px;

        }
    }

    .dialog-footer {
        text-align: center;
    }
}

.table-header {
    background-color: rgb(230, 242, 255) !important;
    font-weight: bold;
}

.demo-form-inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 10px;
}

// 优化标签样式
:deep(.el-tag) {
    font-size: 12px;
    padding: 2px 8px;
}

// 表格溢出提示优化
:deep(.el-table .cell) {
    white-space: nowrap;
}

// 分页样式优化
:deep(.el-pagination) {
    margin-top: 15px;
}
</style>